import AdSenseConfig from '../config/adsense.config';

export const ADSENSE_SCRIPT_SRC = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';

let pending = null;

/**
 * Injects the AdSense loader on demand, once per page load.
 *
 * The loader is deliberately not in index.html: as soon as it runs, Google
 * fires a page-level ad request, and doing that on the landing, login, policy
 * and OBS screens is what AdSense flags as "ads on screens without publisher
 * content". Only screens that actually render an AdSenseAd load it.
 *
 * Resolves to true once the script is on the page, false if it failed to load
 * (ad blocker, offline, CSP) so callers can skip the slot push.
 */
export function loadAdSense() {
  if (typeof document === 'undefined') return Promise.resolve(false);
  if (pending) return pending;

  if (document.querySelector(`script[src^="${ADSENSE_SCRIPT_SRC}"]`)) {
    pending = Promise.resolve(true);
    return pending;
  }

  pending = new Promise((resolve) => {
    const script = document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = `${ADSENSE_SCRIPT_SRC}?client=${AdSenseConfig.publisherId}`;
    script.onload = () => resolve(true);
    script.onerror = () => {
      pending = null;
      script.remove();
      resolve(false);
    };
    document.head.appendChild(script);
  });
  return pending;
}

/** Test-only: forget the in-flight promise so each test starts clean. */
export function resetAdSenseLoader() {
  pending = null;
}
